var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniTransport03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 253,
    viewBox: "0 0 259 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.574219,
    y: 0.0527344,
    width: 258,
    height: 252,
    fill: "#D38D8D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_502_13316",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 253
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.574219,
    y: 0.0527344,
    width: 258,
    height: 252,
    fill: "#D38D8D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_502_13316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.761 178.57C136.761 175.257 139.447 172.57 142.761 172.57H168.558C171.871 172.57 174.558 175.257 174.558 178.57V210.361C174.558 213.674 171.871 216.361 168.558 216.361H142.761C139.447 216.361 136.761 213.674 136.761 210.361V178.57Z",
    fill: "#191244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.45 178.57C226.45 175.257 229.136 172.57 232.45 172.57H258.247C261.561 172.57 264.247 175.257 264.247 178.57V210.361C264.247 213.674 261.561 216.361 258.247 216.361H232.45C229.136 216.361 226.45 213.674 226.45 210.361V178.57Z",
    fill: "#191244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.158 43.7441C124.158 39.3259 127.74 35.7441 132.158 35.7441H268.847C273.265 35.7441 276.847 39.3259 276.847 43.7441V195.021C276.847 199.439 273.265 203.021 268.847 203.021H132.158C127.74 203.021 124.158 199.439 124.158 195.021V43.7441Z",
    fill: "#8F87F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.847 35.7441H132.158C127.74 35.7441 124.158 39.3259 124.158 43.7441V60.7373L234.279 203.021H268.847C273.265 203.021 276.847 199.439 276.847 195.021V43.7441C276.847 39.3259 273.265 35.7441 268.847 35.7441Z",
    fill: "#353071"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.158 158.605H276.847V164.86H124.158V158.605Z",
    fill: "#353071"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.847 164.86V158.605H199.925L204.632 164.86H276.847Z",
    fill: "#120E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.76 53.8203C136.76 51.6112 138.551 49.8203 140.76 49.8203H260.244C262.453 49.8203 264.244 51.6112 264.244 53.8203V111.039C264.244 113.248 262.453 115.039 260.244 115.039H140.76C138.551 115.039 136.76 113.248 136.76 111.039V53.8203Z",
    fill: "#C3CCFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.244 49.8203H140.76C138.551 49.8203 136.76 51.6112 136.76 53.8203V75.6203C136.76 76.5085 137.055 77.3715 137.6 78.0731L165.095 113.492C165.852 114.468 167.019 115.039 168.254 115.039H260.244C262.453 115.039 264.244 113.248 264.244 111.039V53.8203C264.244 51.6112 262.453 49.8203 260.244 49.8203Z",
    fill: "#9AA5E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.684 49.8203H168.702L200.55 115.039H184.531L152.684 49.8203Z",
    fill: "#F3F5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.557 49.8203H179.429L211.276 115.039H206.404L174.557 49.8203Z",
    fill: "#F3F5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.557 174.57C174.557 173.466 175.452 172.57 176.557 172.57H224.447C225.552 172.57 226.447 173.466 226.447 174.57V187.869C226.447 188.973 225.552 189.869 224.447 189.869H176.557C175.452 189.869 174.557 188.973 174.557 187.869V174.57Z",
    fill: "#353071"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.447 188.249V174.57C226.447 173.466 225.552 172.57 224.447 172.57H210.777L223.542 189.234C223.848 189.634 224.324 189.869 224.827 189.869C225.722 189.869 226.447 189.144 226.447 188.249Z",
    fill: "#120E47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.543 176.275C177.543 175.723 177.991 175.275 178.543 175.275H222.462C223.014 175.275 223.462 175.723 223.462 176.275V186.162C223.462 186.714 223.014 187.162 222.462 187.162H178.543C177.991 187.162 177.543 186.714 177.543 186.162V176.275Z",
    fill: "#F3F5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.463 186.662V176.275C223.463 175.723 223.015 175.275 222.463 175.275H212.922L221.997 187.162H222.963C223.239 187.162 223.463 186.938 223.463 186.662Z",
    fill: "#6762AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.76 176.275C136.76 175.723 137.207 175.275 137.76 175.275H158.663C159.215 175.275 159.663 175.723 159.663 176.275V186.162C159.663 186.714 159.215 187.162 158.663 187.162H137.76C137.207 187.162 136.76 186.714 136.76 186.162V176.275Z",
    fill: "#353071"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.31 185.125V177.195H191.289C193.107 177.195 194.076 178.302 194.082 179.824C194.076 181.341 193.096 182.442 191.267 182.442H189.733V185.125H188.31ZM189.733 181.27H191.07C192.143 181.264 192.625 180.662 192.625 179.824C192.625 178.975 192.143 178.389 191.07 178.389H189.733V181.27Z",
    fill: "#353071"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.659 185.213C195.188 185.213 194.799 184.829 194.805 184.358C194.799 183.898 195.188 183.521 195.659 183.515C196.113 183.521 196.502 183.898 196.502 184.358C196.502 184.829 196.113 185.213 195.659 185.213Z",
    fill: "#353071"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.915 185.125V177.195H200.894C202.713 177.195 203.682 178.302 203.687 179.824C203.682 181.341 202.702 182.442 200.872 182.442H199.339V185.125H197.915ZM199.339 181.27H200.675C201.749 181.264 202.231 180.662 202.231 179.824C202.231 178.975 201.749 178.389 200.675 178.389H199.339V181.27Z",
    fill: "#353071"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.174 177.195V185.125H204.772V177.195H206.174Z",
    fill: "#353071"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.15 185.246C208.359 185.246 207.258 184.052 207.258 182.19C207.258 180.35 208.375 179.101 210.073 179.101C211.53 179.101 212.789 180.016 212.789 182.102V182.54H208.638C208.66 183.553 209.257 184.156 210.16 184.15C210.774 184.156 211.185 183.893 211.365 183.537H212.734C212.482 184.567 211.53 185.246 210.15 185.246ZM208.644 181.587H211.453C211.447 180.777 210.9 180.185 210.095 180.185C209.257 180.185 208.693 180.832 208.644 181.587Z",
    fill: "#353071"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.342 176.275C241.342 175.723 241.79 175.275 242.342 175.275H263.245C263.797 175.275 264.245 175.723 264.245 176.275V186.162C264.245 186.714 263.797 187.162 263.245 187.162H242.342C241.79 187.162 241.342 186.714 241.342 186.162V176.275Z",
    fill: "#120E47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.647,
    y: 82.6758,
    width: 7.51089,
    height: 2.5876,
    fill: "#353071"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.397 83.4297C108.397 82.8774 108.845 82.4297 109.397 82.4297H118.902C119.454 82.4297 119.902 82.8774 119.902 83.4297V98.613C119.902 99.1653 119.454 99.613 118.902 99.613H109.397C108.845 99.613 108.397 99.1653 108.397 98.613V83.4297Z",
    fill: "#353071"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.284 84.5371C109.284 83.9848 109.732 83.5371 110.284 83.5371H118.016C118.568 83.5371 119.016 83.9848 119.016 84.5371V97.506C119.016 98.0583 118.568 98.506 118.016 98.506H110.284C109.732 98.506 109.284 98.0583 109.284 97.506V84.5371Z",
    fill: "#C3CCFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.921 83.5371H110.284C109.732 83.5371 109.284 83.9848 109.284 84.5371V86.079C109.284 86.2622 109.335 86.4419 109.43 86.5985L116.377 98.0255C116.559 98.3239 116.883 98.506 117.232 98.506H118.016C118.568 98.506 119.016 98.0583 119.016 97.506V96.4602C119.016 96.2802 118.967 96.1035 118.875 95.9488L111.78 84.0257C111.6 83.7228 111.273 83.5371 110.921 83.5371Z",
    fill: "#F3F5FF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_502_13316)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 174.557,
    y: 124.809,
    width: 51.892,
    height: 3.10077,
    rx: 1.55038,
    fill: "#120E47"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M174.557 125.855V126.908C174.557 127.46 175.004 127.908 175.557 127.908H176.165L174.557 125.855Z",
    fill: "#353071"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_502_13316)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 174.557,
    y: 131.334,
    width: 51.892,
    height: 3.10077,
    rx: 1.55038,
    fill: "#120E47"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_502_13316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.41 131.334H176.107C175.251 131.334 174.557 132.028 174.557 132.884C174.557 133.741 175.251 134.435 176.107 134.435H181.217L179.663 132.436C179.122 131.741 178.291 131.334 177.41 131.334Z",
    fill: "#353071"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_502_13316)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 174.557,
    y: 137.857,
    width: 51.892,
    height: 3.10077,
    rx: 1.55038,
    fill: "#120D47"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_502_13316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.793 137.857H176.107C175.251 137.857 174.557 138.552 174.557 139.408C174.557 140.264 175.251 140.958 176.107 140.958H186.257L185.707 140.253C184.525 138.741 182.712 137.857 180.793 137.857Z",
    fill: "#353071"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M182.242 242.053V222.256H190.008C194.506 222.256 197.09 225.031 197.09 228.928C197.09 232.879 194.465 235.6 189.898 235.6H186.344V242.053H182.242ZM186.344 232.291H189.242C191.676 232.291 192.865 230.924 192.852 228.928C192.865 226.959 191.676 225.633 189.242 225.619H186.344V232.291ZM201.055 242.299C199.77 242.299 198.73 241.273 198.758 240.002C198.73 238.744 199.77 237.719 201.055 237.732C202.271 237.719 203.324 238.744 203.324 240.002C203.324 241.273 202.271 242.299 201.055 242.299ZM206.66 242.053V222.256H214.426C218.924 222.256 221.508 225.031 221.508 228.928C221.508 232.879 218.883 235.6 214.316 235.6H210.762V242.053H206.66ZM210.762 232.291H213.66C216.094 232.291 217.283 230.924 217.27 228.928C217.283 226.959 216.094 225.633 213.66 225.619H210.762V232.291ZM228.07 222.256V242.053H224.023V222.256H228.07ZM237.941 242.354C233.389 242.34 230.6 239.4 230.613 234.697C230.6 230.117 233.43 227.014 237.777 227.014C241.674 227.014 244.75 229.475 244.75 234.533V235.682H234.605C234.605 237.924 235.932 239.305 238.023 239.318C239.404 239.305 240.389 238.703 240.785 237.814H244.641C244.066 240.562 241.605 242.34 237.941 242.354ZM234.605 233.139H240.922C240.908 231.334 239.664 230.035 237.859 230.049C236 230.035 234.688 231.43 234.605 233.139Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_502_13316",
    x: 174.557,
    y: 124.809,
    width: 51.8916,
    height: 3.30156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0469945 0 0 0 0 0.0351389 0 0 0 0 0.183333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_502_13316"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_502_13316",
    x: 174.557,
    y: 131.334,
    width: 51.8916,
    height: 3.30156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0469945 0 0 0 0 0.0351389 0 0 0 0 0.183333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_502_13316"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_502_13316",
    x: 174.557,
    y: 131.334,
    width: 6.66016,
    height: 3.30156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0704896 0 0 0 0 0.0523437 0 0 0 0 0.279167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_502_13316"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_502_13316",
    x: 174.557,
    y: 137.857,
    width: 51.8916,
    height: 3.30156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0469945 0 0 0 0 0.0351389 0 0 0 0 0.183333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_502_13316"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_502_13316",
    x: 174.557,
    y: 137.857,
    width: 11.7012,
    height: 3.30156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0704896 0 0 0 0 0.0523437 0 0 0 0 0.279167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_502_13316"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniTransport03);
export default __webpack_public_path__ + "static/media/mini_transport_03.3decdde048a69e492c10165439cfa0cc.svg";
export { ForwardRef as ReactComponent };